import { FormConfig } from '@/entities/assets/hooks/useFormFields';
import { AssetDto } from '@/shared/lib/sj-orm';
import { isEmpty } from '@/shared/utils/misc';
import { numbers } from '@/shared/utils/numbers';

import { CurrencyValue } from './types';

export const formatAssetValue = (data: CurrencyValue): string => {
  return isEmpty(data, true) ? '' : numbers.formatPrice(data.value ?? 0, data.from);
};

export const getSortedItems = (formData: FormConfig, formKeys: Array<keyof AssetDto>) => {
  let orderCount = formKeys.length;

  const formItems = formKeys
    .map((key) => ({
      order: formData[key].order === undefined ? orderCount++ : Number(formData[key].order),
      key,
    }))
    .sort((a, b) => a.order - b.order);

  return formItems.map(({ key }) => key);
};
